<template>
    <span class="rounded-circle bg-dark text-white px-2 py-1">
        {{ total }}
    </span>
</template>

<script>
import {mapState, mapGetters} from "vuex";

export default {
    name: "CartQuantityIndicator",
    computed: {
        ...mapState('cart', {
            total: state => state.total,
        }),
    }
}
</script>

<style scoped>

</style>
